const initialState = {
  isVisible: false,
  title: "",
  message: "",
  onOk: null,
  loading: false,
  async: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "confirm-action":
      return {
        ...state,
        title: action.title,
        message: action.message,
        onOk: action.onOk,
        isVisible: true,
        loading: action.loading,
        async: action.async,
      };
    case "start-loading":
      return {
        ...state,
        loading: true,
      };
    case "stop-loading":
      return {
        ...state,
        loading: false,
      };
    case "hide":
      return initialState;
    default:
      return state;
  }
};

export { reducer, initialState };
